export const Panel = {
  /**
   * 展開や表示対象の状態
   */
  States: {
    /**
     * 閉じ
     */
    CLOSED: 0,
    /**
     * 開き
     */
    OPENED: 2,
  }
}

/**
 * ウィンドウサイズ
 */
export const WindowSize = {
  LARGE: "L",
  MEDIUM: "M",
  SMALL: "S",
}

/**
 * 現在地の取得状況
 */
export const LocationStatus = {
  /**
   * 未取得
   */
  NONE: 0,
  /**
   * 取得中
   */
  LOADING: 1,
  /**
   * 取得失敗
   */
  FAILED: 9,
}

/**
 * 駅の取得状況
 */
export const StationsStatus = {
  /**
   * 読み込み前
   */
  NONE: 0,
  /**
   * 読み込み中
   */
  LOADING: 1,
  /**
   * 読み込み後
   */
  LOADED: 2
}

/**
 * フィルター関連の定数
 */
export const FilterConstants = {
  /**
   * キャンペーングループID
   */
  CAMPAIGN_GROUP_ID: 'campaign_group',
  /**
   * キャンペーンIDプレフィックス
   */
  CAMPAIGN_ID_PREFIX: 'campaign_',
  /**
   * データIDプレフィックス
   */
  DATA_ID_PREFIX: {
    MARKER_GROUP: 'marker-group-',
    SEARCH_CONDITION_GROUP: 'search-condition-group-',
    MARKER: 'marker-',
    SEARCH_CONDITION: 'search-condition-',
  },
  /**
   * フィルター表示場所
   */
  PLACE: {
    FILTERS: 'filters',
  },
}

/**
 * reCAPTCHA アクション名
 */
export const RecaptchaActions = {
  MAP_SHOW_MAP: 'map_show_map',
  POINT_SHOW_MAP: 'point_show_map',
}

/**
 * localStorageのキー（reCAPTCHAの評価結果を保存）
 */
export const LOCAL_STORAGE_KEY_VERIFY_RECAPTCHA_RESULT = 'sl_verify'

/**
 * localStorageのキー（GA4のセッションタイムアウトに合わせてタブ間共有）
 */
export const SESSION_STORAGE_KEY_PV_COUNT = 'sl_session_pv_count'
export const SESSION_STORAGE_KEY_START = 'sl_session_start'
export const SESSION_STORAGE_KEY_LAST_ACTIVITY = 'sl_session_last_activity'
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000
